<main>
    <div class="container main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-inner-container">
                    <article class="article-content">
                        <div *ngIf="modulecontent" class="text-center">
                            <h1>{{modulecontent.Title}}</h1>
                        </div>

                        <div *ngIf="modulecontent && modulecontent.Entry.VendorVideoID" class="row embedded-video">
                            <div [innerHtml]="theVideoUrl"></div>
                        </div>

                        <a *ngIf="modulecontent && !modulecontent.Entry.VendorVideoID"
                            [routerLink]="['/videocourseslandingview']">
                            <img class="logo" src="/assets/img/subscribe_today.png" alt="Subscribe to Lawshelf"
                                width="100%" />
                        </a>
                        <br />

                        <app-social-media></app-social-media>
                        <br />
                        <!--
                        <div class="row margin-bottom-10">
                            <div *ngIf="modulecontent && modulecontent.Entry.HasQuiz"
                                class="col-lg-9 col-md-9 col-sm-12 article-column">
                                <div style="margin-top: 10px;">
                                    <a [routerLink]='["/videocoursesmoduleexamview", alias]'
                                        class="btn login-register-buttons btn-lg" type="button">Take self-test</a>
                                </div>
                            </div>
                        </div>
                        -->

                        <app-see-also *ngIf="modulecontent && modulecontent.SeeAlso && modulecontent.SeeAlso.length > 0"
                            [displayAmount]="3" [concepts]="modulecontent.SeeAlso"></app-see-also>
                        <div style=""></div>
                        <div *ngIf="modulecontent" [innerHTML]="textPart1 | safeHtml "
                            class="col-lg-12 col-md-12 col-sm-12"></div>
                        <app-header-ad [position]="'middle'" *ngIf="modulecontent"></app-header-ad>
                        <div *ngIf="modulecontent" [innerHTML]="textPart2 | safeHtml "
                            class="col-lg-12 col-md-12 col-sm-12"></div>
                        <div class="col-sm-12">
                            <app-see-also
                                *ngIf="modulecontent && modulecontent.SeeAlso && modulecontent.SeeAlso.length > 3"
                                [displayAmount]="100" [concepts]="modulecontent.SeeAlso"></app-see-also>
                        </div>

                    </article>

                </div>
            </div>
        </div>
        <div *ngIf="modulecontent" class="row margin-top-10 margin-left-10">
            <div class="col-sm-12 article-column">
                <div style="margin-top: 10px;">
                    <a [routerLink]="['/videocoursescontentview',modulecontent.DigitalBadgeCourse.Information.Alias]"
                        class="btn login-register-buttons btn-lg" type="button">Back to video-course
                        overview</a>
                </div>
            </div>
        </div>
        <div class="row margin-top-10" style="display: inline">
            <app-header-ad [position]="'bottom'"></app-header-ad>
        </div>
    </div>
</main>